export enum ActionConstants {
	SET_WITHDRAWS = 'set_withdraws',
	ADD_WITHDRAW = 'add_withdraw',
}
